module.exports = __webpack_public_path__ + "static/img/pay_qrpay_left@3x.a7eff91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay_qrpay_left@3x.png
// module id = BTVH
// module chunks = 1